import { render, staticRenderFns } from "./addSupplier.vue?vue&type=template&id=3997df8c&scoped=true&"
import script from "./addSupplier.vue?vue&type=script&lang=js&"
export * from "./addSupplier.vue?vue&type=script&lang=js&"
import style0 from "./addSupplier.vue?vue&type=style&index=0&id=3997df8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3997df8c",
  null
  
)

export default component.exports